<template>
	<div class="distance"><strong>Distance:</strong> {{ $store.getters.getTotalDistanceString }}</div>
</template>

<script>
export default {
	name: "TotalDistance"
}
</script>